import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {SessionService} from "./services/session-service/session.service";
import {DomSanitizer, Meta, Title} from "@angular/platform-browser";
import {MatIconRegistry} from "@angular/material/icon";
import {HttpService} from "./services/http/http.service";
import {ThemeService} from "./services/theme-service/theme.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent {
  private session = inject(SessionService);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private meta = inject(Meta);
  private title = inject(Title);
  private http = inject(HttpService);
  private themeService = inject(ThemeService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const session = this.session;
    const http = this.http;

    session.setUser();
    http.get('config').subscribe(resp => {
      console.log(
        'config',
        {apiVersion: resp.apiVersion, minimumBuildNumber: resp.minimumBuildNumber}
      )
    })

    if (!!this.session.user?.perfil) {
      if (!this.session.issetFavoritos()) {
        this.session.findFavoritos();
      }
    }

    // Atualizar título
    this.title.setTitle('Guedder ');

    // Atualizar meta description
    this.meta.updateTag({ name: 'description', content: 'description' });

    // Atualizar Open Graph tags
    this.meta.updateTag({ property: 'og:title', content: 'Guedder' });
    this.meta.updateTag({ property: 'og:description', content: 'description' });
    this.meta.updateTag({ property: 'og:image', content: window.location.origin+'/assets/images/logo-guedder-roxo.png' });

    this.matIconRegistry.addSvgIcon(
      "camera",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/camera.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "compartilhar",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/compartilhar.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pix",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/pix.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "paypal",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/paypal_logo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "google_pay",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/google_pay_logo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "apple_pay",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/apple_pay_logo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cartao",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/cartao.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "calendar",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/calendar.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "map",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/map.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "favoritos_desmarcado",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/favoritos_desmarcado.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "favoritos_marcado",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/favoritos_marcado.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "success-venda",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/success-venda.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "transferir",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/new/transferir.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "email",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/new/email.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gerenciar-evento",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/new/gerenciar-evento.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "copiar",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/copiar.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "seguro",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svg/seguro.svg")
    );

    console.log('check update', '13:40')
  }
}
